<template>
    <div class="container-fluid">
        <loading
            :active.sync="isLoading"
            :can-cancel="false"
            loader="dots"
            :is-full-page="fullPage"
            :height="height"
            :width="width"
            background-color="#6b6969"
        ></loading>
        <div class="row">
            <div class="col-md-8 offset-md-2" style="margin-top: 2rem;">
                <h5 class="text-capitalize font-weight-bold cursor-pointer">
                    <a @click="$router.go(-1)" class="text-orange"><i class="fa fa-arrow-left text-orange"></i>
                        Back
                    </a>
                </h5>
            </div>
            <div class="col-12 text-center mt-2 ">
                <h3 class="text-green font-weight-bold mt-0">
                    CALL FOR STARTUPS
                    GTL NATIONAL ACCELERATION PROGRAM
                </h3>
            </div>
        </div>
        <div class="row">
            <div class="col-md-9 offset-md-2 mb-5">
                <div class="card">
                    <div class="card-body">
                        <div class="ml-md-4">
                            <h5><strong>1.0 BACKGROUND</strong></h5>
                            <p>Ghana Tech Lab is an open collaborative tech space for competent digital skills training,
                                seeding innovations and growing startups. Ghana Tech Lab is a joint venture between
                                Innohub Ghana and Kumasi Hive under the E-Transform Project of the Ministry of
                                Communications and funded by the World Bank.</p>
                            <p>Our programs focus on providing a fertile farm for innovative promising Startups in
                                Africa, early stage investments for promising Startups in Africa and the provision of
                                competent digital training that impels the creation of highly skilled digital workforce
                                / Human capital.</p>
                            <h5>1.1 About the Pathways to Sustainable Employment (PaSE) Project</h5>

                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Pathways to Sustainable Employment
                                (PaSE) as intervention by Ghana Tech Lab seeks to locally facilitate a model that
                                leverages
                                a distributed network of hubs across Ghana to deliver integrated entrepreneurship
                                support
                                (skills building, seed funding, incubation, acceleration), with a view to building a
                                pipeline of investment ready firms (more than 70% women-led firms), and linking young
                                people
                                to employment opportunities.</p>


                            <h5>2.0 About the Acceleration Program</h5>
                            <p>Our high-quality Acceleration program addresses the demand for quality Business support
                                (with
                                a priority on female-led businesses) towards the provision of high-quality Business
                                Development Services (BDS) to existing businesses.</p>
                            <p>The Acceleration program seeks to achieve the following:</p>
                            <ul class="ml-md-4">
                                <li>Identify industries most relevant within the specific communities. Targeted training
                                    and
                                    resources for supporting tools will then be provided to cater their business
                                    development
                                    services to SMEs within these sectors.
                                </li>
                                <li>set for hubs to nurture selected businesses through a series of tailored, localized
                                    trainings, mentorship, professional advisory services and executable growth tasks.
                                </li>
                            </ul>
                            <p>High-growth SMEs identified by partner hubs will be assessed and prepared through our
                                acceleration program.</p>
                            <p>&nbsp;</p>
                            <p>The program&rsquo;s cohort will be crowned with a Startup pitch and investment forum
                                dubbed
                                the Ghana Startup Summit (GSS), where all the accelerated businesses get to pitch to a
                                panel
                                of Investors (both Angel Investors and Venture Capital Investors) to help secure growth
                                funding.</p>
                            <p>The program is targeted at tech-driven and tech-enabled startups across the country.
                                Selected
                                startups will receive tailored support through an initial Needs Assessment to be
                                performed
                                at the beginning of the program to identify gaps within each selected startup&rsquo;s
                                business model.</p>
                            <p>&nbsp;</p>
                            <h5>1.4 Benefits of Program </h5>
                            <p>Our acceleration program is designed to help scale your startups and assist you achieve
                                measurable outcomes.</p>
                            <p>&nbsp;</p>
                            <div class="text-center"><img src="@/assets/doc_image.png" class="img-fluid" alt=""/></div>
                            <h5>3.0 Selection Criteria</h5>
                            <p>To help you determine if your startup falls under the GTL Accelerator core focus area,
                                kindly
                                assess the current standing of your startup against the following criteria</p>
                            <ol>
                                <li><strong>Number of years in operation </strong>
                                    <ul>
                                        <li>Your startup must be operational between 6 months to 3 years</li>
                                    </ul>
                                </li>
                                <li><strong>Registration status of startup</strong>
                                    <ul>
                                        <li>To be eligible for selection, your startup must be registered with the
                                            Registrar General&rsquo;s
                                            Department.
                                        </li>
                                    </ul>
                                </li>
                                <li><strong>The startup must have a tech enabled product</strong>
                                    <ul>
                                        <li>The acceleration program is designed to support startups tackling a
                                            challenge using
                                            technology. Your product must hence be either tech-driven or tech-enabled.
                                        </li>
                                    </ul>
                                </li>
                                <li><strong>Team capacity </strong>
                                    <p>Your startup must have at least a business lead and a tech lead. Beyond this, the
                                        following
                                        will also be assessed during the application process:</p>
                                    <ul>
                                        <li>Team size</li>
                                        <li>Strength of business lead</li>
                                        <li>Strength of technical lead</li>
                                    </ul>
                                </li>
                                <li><strong>Already have a working MVP</strong>
                                    <ul>
                                        <li>You must prove that you already have a working MVP on the market that can be
                                            further
                                            refined or improved through the acceleration program.
                                        </li>
                                    </ul>
                                </li>
                                <li><strong>Startup has the ability to scale (based on business model)</strong>
                                    <ul>
                                        <li>Startup&rsquo;s growth or expansion plans will be assessed through the
                                            application
                                            and
                                            selection process
                                        </li>
                                    </ul>
                                </li>
                                <li><strong>The startup must have built some level of traction (active/engaged clients
                                    or
                                    made verifiable sales)</strong>
                                    <ul>
                                        <li>Your startup must have already made some revenue and looking forward to
                                            raising
                                            extra
                                            funding (seed or Serie A) for their business
                                        </li>
                                    </ul>
                                </li>
                            </ol>
                            <h5>4.0 Application Guidelines</h5>
                            <div v-if="readMoreButton">
                                <p>Interested applicants or startups should submit their applications using the link
                                    provided on
                                    the attached flyer.</p>
                                <p>For further enquiries, kindly reach the acceleration lead via email: <a href= "mailto: acceleration@ghanatechlab.com"
                                    class="text-orange">acceleration@ghanatechlab.com</a>
                                </p>
                                <div class="text-center">
                                    <a class="btn btn-green btn-lg" href="https://call-for-startups.netlify.app/apply">Apply for program</a>
                                </div>
                            </div>
                            <div v-else >
                                <button class="btn btn-orange" @click="readMoreButton = true">Read More</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center">
                    <img src="@/assets/MCF.png" class="img-fluid" style="width: 100px" alt="">
                    <img src="@/assets/MOC.png" class="img-fluid" style="width: 200px" alt="">
                    <img src="@/assets/World_bank.png" class="img-fluid" style="width: 100px" alt="">
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    /* eslint-disable */
    import "vue-loading-overlay/dist/vue-loading.css";

    export default {
        name: "ScholarshipForm",
        data() {
            return {
                isLoading: false,
                fullPage: true,
                height: 128,
                width: 128,
                readMoreButton: false
            };
        },
        components: {
            Loading: () => import('vue-loading-overlay'),
        },
        methods: {
        },
        created() {
            document.title = `${this.$route.params.name} Application|| Ghana Startup Summit`;
        },
    };
</script>

<style scoped>
    .container-fluid {
        height: 100vh;
    }

    ol > li, li {
        margin-left: 2.5rem;
        margin-top: 0.5rem;
    }


    form {
        width: 80%;
        margin: 0 auto;
    }

    h5 {
        font-weight: bolder;
    }


    .fileInput + label {
        font-size: 0.9375em;
        color: var(--blue);
    }

    .text-center label {
        border-bottom: 1px solid #0599a9;
        width: 27%;
    }

    .text-center label:hover {
        cursor: pointer;
    }

    section > div > label {
        color: black !important;
        font-size: 16.5px !important;
        margin-bottom: 0.6rem !important;
    }

    section > div textarea {
        height: 60px;
        padding: 0.4rem;
    }

    .social {
        padding: 3px 5px 1px;
        border-radius: 5px;
        border: 1px solid #ffffff;
        margin-right: 25px;
    }
</style>